var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"color":"warning","text-color":"white","disabled":"","small":""}},[_vm._v("Fee account")])
}
var staticRenderFns = []

export { render, staticRenderFns }